﻿import { FIQAssist  } from "../app";
import { Component, Inject } from "@fiqas/angular-utils";
import { IsProcessingService } from "../services/isProcessingService";

@Component({
    module: FIQAssist,
    selector: 'processingindicator',
    template: `<div class="processingindicator cssload-container" ng-class="{isprocessing:$ctrl.isprocessing}">
	<div class="cssload-loading"><i></i><i></i><i></i><i></i></div>
</div>`
})
export class ProcessingIndicator {

    public isprocessing: boolean;
    private undoWatch: any = null;

    constructor(
        @Inject('$scope') private $scope : ng.IScope,
        @Inject() private isProcessingService: IsProcessingService) {
    }

    public $onInit() {
        this.undoWatch = this.isProcessingService.addListener((status) => {
            this.isprocessing = status;
        });
        this.isprocessing = this.isProcessingService.IsProcessing;
    }

    public $onDestroy() {
        this.undoWatch();
    }
}

